import React from "react";
import { BsArrowRightShort } from "react-icons/bs";

import "./style.scss";

const Arrow = () => {
    return (
        <span className="arrow-icon">
            <BsArrowRightShort />
        </span>
    );
};

export default Arrow;
